// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"185":"47919657","254":"91b853cf","489":"11d6f0a4","513":"bf255b65","574":"69be56f3","808":"a758e97b","937":"4ab3a9b8"}[chunkId] + ".js";
};